import { Flex } from '@chakra-ui/react';
import styled from 'styled-components';
export const WrapperMainTerms = styled.div`
  padding: 5rem 7rem;
  display: flex;
  justify-content: center;
  width: 100%;
  background: white;

  h1 {
    color: ${({ theme }) => theme.colors.tertiary};
    line-height: 2rem;
    margin-bottom: 1rem;
    font-size: 1.875rem;
  }

  p {
    margin-bottom: 1.5rem;
    color: #333333;
    font-weight: 500;
    font-size: 0.85rem;
  }

  ul {
    list-style-type: none;
    margin-bottom: 3rem;
  }

  ul,
  li {
    color: #333333;
    font-weight: 500;
    font-size: 0.85rem;
  }

  li {
    margin-bottom: 1.5rem;
    &:before {
      content: '. ';
    }

    margin-bottom: 0rem;
  }

  ul > p {
    margin-bottom: 0rem;
  }
`;

export const WrapperContent = styled(Flex)`
  flex-direction: column;
  width: 100%;

  .terms span {
    display: flex;
    align-items: center;
  }

  .terms a {
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
    color: #050505;
    margin-left: 0.2rem;
    margin-right: 0.2rem;
  }
`;

interface Iprops {
  isActive: boolean;
}

export const ButtonGoSimulator = styled.a<Iprops>`
  display: inline;
  text-align: center;
  line-height: none;
  padding-block: 5px;
  width: 7.125rem;
  height: 1.9rem;
  background: ${({ theme, isActive }) => (isActive ? theme.colors.tertiary : theme.colors.gray100)};
  color: ${({ theme }) => theme.colors.white};
  font-weight: 400;
  font-size: 0.75rem;
  border-radius: 4px;

  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
`;
